var map = {
	"./Ksor.jpg": 7103,
	"./Mepho.jpg": 8274,
	"./Moim-1.0.jpg": 8668,
	"./Moim-2.0.jpg": 5295,
	"./Moim-4.0.jpg": 7657,
	"./Murm.jpg": 3735,
	"./plant1.jpg": 2194,
	"./plant2.jpg": 1453,
	"./plant4.jpg": 2179,
	"./plantEf.jpg": 2490,
	"./plantMob.jpg": 5509,
	"./plantReg.jpg": 5817,
	"./png/Ksor1.jpg": 5978
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3009;